import { useAuthContext } from "@/contexts/AuthContext"
import { LoadingScreen } from "@/components/ui/loading-spinner"
import { useNavigate } from "react-router-dom"
import Layout from "@/components/Layout/Layout"
import { UserTournaments } from "@/components/Tournaments/UserTournaments"
import { Card, CardContent } from "@/components/ui/card"

const MyTournaments = () => {
  const { userInfo, loading, isAuthenticated } = useAuthContext()
  const navigate = useNavigate()

  if (loading) {
    return <LoadingScreen message="Cargando torneos..." />
  }

  if (!isAuthenticated) {
    navigate("/login")
    return null
  }

  const person = userInfo?.User?.Person

  if (!person) {
    return (
      <Layout>
        <div className="container mx-auto py-8">
          <Card>
            <CardContent className="py-8 text-center">
              <p className="text-muted-foreground">No se encontró información del usuario</p>
            </CardContent>
          </Card>
        </div>
      </Layout>
    )
  }

  return (
    <Layout>
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-6">
        <UserTournaments personId={person.id} />
      </div>
    </Layout>
  )
}

export default MyTournaments
